import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { DateTime } from "luxon";
import { MatDialog, MatPaginator, PageEvent } from '@angular/material';
import { HttpService } from '../http.service';
import { SnackbarService } from '../snackbar.service';
import { Subscription } from 'rxjs/internal/Subscription';
import { EventService } from '../event.service';
import { JsplDetailsViewComponent } from '../jspl-details-view/jspl-details-view.component';

@Component({
  selector: 'app-en-route-vehicles',
  templateUrl: './en-route-vehicles.component.html',
  styleUrls: ['./en-route-vehicles.component.scss']
})
export class EnRouteVehiclesComponent implements OnInit {
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild("addRemarkDialog", { static: true }) addRemarkDialog: TemplateRef<any>;
  @ViewChild("showData", { static: true }) showData: TemplateRef<any>;
  pageEvent: PageEvent;
  showLoader = false;
  fromDate: any = '';
  toDate: any = '';
  currentUnit = true;
  displayedColumns = ["sno", "vehicleDetails", "address", "driverDetails", "carrierDetails", "customerDetails", "estimatedDeliveryDate", "gateEntry", "material", "gateout", "etaSlab", "idleSince", "remarks", "customerLocationEntry", "action"];
  rowDisplayedColumns = ['sno', 'gate_entry_no', 'vehicle_details', 'od_status', 'driver_details'];
  enRouteVehicles = [];
  enRouteVehiclesFilter: any = {
    limit: 0,
    skip: 0,
  };
  searchVehicleNo:any = '';
  vehicle_number:any  = '';
;
  totalvehicles = 0;
  shipperUpdates: Subscription;
  reasons: any;
  delay_reason: any;
  attachedDriver: any;
  dialogRef: any;
  rowData: any;
  odNumber;
  vehicleNumber;
  showDialogRef: any;
  selectedRowIndex: any;


  constructor(private http: HttpService, private snackBar: SnackbarService, private events: EventService, private dialog: MatDialog,) { }
  ngOnInit(): void {
    let currendateTime: any = DateTime.local().minus({ hours: 296 });
    this.fromDate = new Date(currendateTime);
    this.toDate = new Date();
    this.getEnRouteVehicles();
  }

  getEnRouteVehicles(filter: any = {}) {
    this.showLoader = true;
    filter.limit = this.paginator.pageSize || 200;
    filter.skip =
      this.paginator.pageIndex * (this.paginator.pageSize || filter.limit);
    if(this.fromDate) {
      filter.from = DateTime.fromJSDate(this.fromDate).startOf("day").toUTC()
    }
    if(this.toDate) {
      filter.to = DateTime.fromJSDate(this.toDate).endOf("day").toUTC()
      
    }
    filter.allUnit = true;
    if(this.currentUnit){
      filter.allUnit = false;
    }
    filter.shipment_status = 'ALL';
      
    if (this.searchVehicleNo) filter.vehicle_no = this.searchVehicleNo;
      this.http.get('enroute/many', filter, 2).subscribe((data: any) => {
        if (data.statusCode === 200) {
          this.enRouteVehicles = data.data.records;
          this.totalvehicles = data.data.count;
        }
      }, (err: any) => {
        this.snackBar.openSnackBar(err.error.message, '', 'err');
      })
  }

  edit() {

  }
  pageNavigate(event: PageEvent) {
    this.enRouteVehiclesFilter.limit = event.pageSize;
    this.enRouteVehiclesFilter.skip = event.pageIndex * event.pageSize;
    this.getEnRouteVehicles(this.enRouteVehiclesFilter);
  }
  download() {
    let request: any = {};
    if (this.fromDate && this.toDate) {
      const from: any = DateTime.fromJSDate(this.fromDate)
        .startOf("day")
        .toUTC();
      const to: any = DateTime.fromJSDate(this.toDate).endOf("day").toUTC();

      request.from = from.ts;
      request.to = to.ts;
    }
    let url = 'vehicleRouteDetails/all';
    if (this.currentUnit) url = 'vehicleRouteDetails'
    this.http.post("v1/reports/" + url, request, 2).subscribe(
      (response: any) => {

        this.showLoader = false;
        window.open(response.data.link, "_blank");
      },
      (err: any) => {
        this.showLoader = false;
        this.snackBar.openSnackBar(err.error.message, "", "err");
      }
    );
  }
  openUpdateRemarks(element) {
    this.attachedDriver = element._id;
    this.delay_reason = element.delayReason;
    this.dialogRef = this.dialog.open(this.addRemarkDialog);
    this.getShipperRemarks();
  }
  updateRemarks() {
    this.http.put('enroute/delay_reason', { _id: this.attachedDriver, delay_reason: this.delay_reason }, 2).subscribe(
      (data: any) => {
        if (data.statusCode === 200) {
          this.snackBar.openSnackBar('Updated successfully');
          this.getEnRouteVehicles();
          this.dialogRef.close();
        }
      },
      (err: any) => {
        this.snackBar.openSnackBar(err.error.message, '', 'err');
      }
    )
  }
  getShipperRemarks() {
    this.http.get('constants/get_reasons?name=jsplOBDremarks').subscribe(
      (data: any) => {
        if (data.statusCode === 200) {
          this.reasons = data.data[0].reason;
        }
      },
      (err: any) => {
        this.snackBar.openSnackBar(err.error.message, '', 'err');
      }
    );
  }
  getOrderStatus(row, i) {
    this.selectedRowIndex = i;
    this.rowData = [];
    this.vehicleNumber = row.vehicle;
    this.odNumber = row.od_status || 'N/A';
    const dialogRef = this.dialog.open(JsplDetailsViewComponent, {
      data: this.rowData,
      width: '1250px',
      maxWidth: '95vw !important'
    });
    this.rowData.push(row);
  }
  allUnitData(){
    this.currentUnit=!this.currentUnit;
    this.getEnRouteVehicles();
  }

  applyFilter(filterValue: string, type: string) {
    if (type == "vehicleno") {
      this.searchVehicleNo = filterValue;
      if (filterValue.length == 0 || filterValue.length > 3) {
        this.getEnRouteVehicles();
      }
    }
  }
  clearVehicleNumber() {
    this.vehicle_number = "";
    this.applyFilter("", "vehicleno");
  }


}
